import { facebookGraphBaseUrl } from 'app.constants';
/**
 * Make requests to Facebook API that requires only access tokens got from
 * Facebook Login dialog.
 *
 * @deprecated Use backend endpoints to make request to Facebook API. This helps to track issues.
 */
export class FacebookService {
    static $inject = ['$http'];
    constructor($http) {
        'ngInject';
        this.$http = $http;
    }
    async getUserAccounts(limit, after, accessToken) {
        const httpResponse = await this.$http({
            method: 'GET',
            url: `${facebookGraphBaseUrl}/me/accounts`,
            params: {
                access_token: accessToken,
                method: 'get',
                after,
                limit,
            },
        });
        return httpResponse.data;
    }
    async getUserPermissions(accessToken) {
        const httpResponse = await this.$http({
            method: 'GET',
            url: `${facebookGraphBaseUrl}/me/permissions`,
            params: {
                access_token: accessToken,
                method: 'get',
            },
        });
        return httpResponse.data.data;
    }
    async me(accessToken) {
        const httpResponse = await this.$http({
            method: 'GET',
            url: `${facebookGraphBaseUrl}/me`,
            params: {
                access_token: accessToken,
                fields: ['picture', 'name'].join(', '),
                method: 'get',
                return_scopes: true,
                scope: ['public_profile', 'manage_pages', 'pages_messaging'].join(','),
            },
        });
        return httpResponse.data;
    }
    async getPagePicture(pageId, accessToken) {
        const httpResponse = await this.$http({
            method: 'GET',
            url: `${facebookGraphBaseUrl}/${pageId}/picture`,
            params: {
                redirect: false,
                method: 'get',
                access_token: accessToken,
            },
        });
        return httpResponse.data;
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
FacebookService.$inject = ['$http'];
